<template>
  <div>
    <img
      v-if="isVisible && image && image.urlWithProtocol"
      class="articleid__media"
      :class="getClass()"
      :style="getStyle()"
      :src="image.urlWithProtocol" :alt="image.title || ''"
      :srcset="image.srcset"
      @error="hide"
    />
    <div v-if="image?.caption || image?.source" class="image-container__caption">
      <span v-if="image?.caption" class="image-container__title">{{ image?.caption }}</span>
      <span v-if="image?.caption && image?.source" class="image-container__divider" />
      <span v-if="image?.source" class="image-container__source">{{ $t('artobjects.source') }}: {{ image?.source }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type {PropType} from "vue";
import type AssetLocal from "../../../../libs/interfaces/AssetLocal";

const {
  image,
  width,
  height
} = defineProps({
  image: {type: Object as PropType<AssetLocal>, required: false},
  width: {type: Number, required: false},
  height: {type: Number, required: false},
})

const isVisible = ref(true)

const hide = () => {
  console.log('image error')
  // isVisible.value = false
}

const getClass = () => {
  if (height || width) {
    return 'custom-size'
  }
  return 'object-cover'
}

const getStyle = () => {
  let style = ''
  if (height && !width) {
    style = style + `height: ${height}px;`
  } else if (width) {
    style = style + `width: ${width}px;`
  }
  return style
}

</script>

<style lang="postcss" scoped>
</style>
